import { lazy } from "react";

import { Paths } from "../common/constants";
import LazyLoader from "../components/routesContainer";
import AccountListing from "../pages/accounts-management";
import AccountDetails from "../pages/accounts-management/account-details";
import AddAccount from "../pages/accounts-management/add-account-microdeposit";

const Analytics = LazyLoader(lazy(() => import("../pages/analytics")));
const MyProfile = LazyLoader(lazy(() => import("../pages/my-profile")));
const EditMyProfile = LazyLoader(
  lazy(() => import("../pages/my-profile/edit-profile")),
);
const CompanyProfile = LazyLoader(
  lazy(() => import("../pages/company-profile")),
);
const EditCompanyProfile = LazyLoader(
  lazy(() => import("../pages/company-profile/edit-company-profile")),
);
const MySupport = LazyLoader(lazy(() => import("../pages/support")));
const RewardsManagement = LazyLoader(
  lazy(() => import("../pages/rewards-management")),
);
const ApiConnections = LazyLoader(
  lazy(() => import("../pages/api-connections")),
);

const AddIntegration = LazyLoader(
  lazy(() => import("../pages/api-connections/add-integration")),
);
const EditIntegration = LazyLoader(
  lazy(() => import("../pages/api-connections/add-integration")),
);

const IntegrationDetails = LazyLoader(
  lazy(() => import("../pages/api-connections/integration-details")),
);

const Batches = LazyLoader(lazy(() => import("../pages/batches")));
const EmployeesManagement = LazyLoader(
  lazy(() => import("../pages/employees-management")),
);
const AddEmployee = LazyLoader(
  lazy(() => import("../pages/employees-management/add-employee")),
);
const Strains = LazyLoader(lazy(() => import("../pages/strains")));
const Announcements = LazyLoader(lazy(() => import("../pages/announcements")));
const QRCodePurchasing = LazyLoader(
  lazy(() => import("../pages/qr-code-purchasing")),
);
const AccessDenied = LazyLoader(lazy(() => import("../pages/access-denied")));
const EditEmployee = LazyLoader(
  lazy(() => import("../pages/employees-management/add-employee")),
);
const EmployeeDetail = LazyLoader(
  lazy(() => import("../pages/employees-management/employee-detail")),
);

// const UploadBatches = LazyLoader(
//   lazy(() => import("../pages/batches/upload-batches"))
// );
const COATokenize = LazyLoader(
  lazy(() => import("../pages/batches/coa-tokenize")),
);
const ProductTokenize = LazyLoader(
  lazy(() => import("../pages/batches/product-tokenize")),
);
const BatcheDetail = LazyLoader(
  lazy(() => import("../pages/batches/batch-detail")),
);
const AllBatches = LazyLoader(
  lazy(() => import("../pages/batches/batch-detail/all-batches")),
);
const AllStrains = LazyLoader(
  lazy(() => import("../pages/batches/batch-detail/all-strains")),
);
const AllStrainsBatchDetail = LazyLoader(
  lazy(() => import("../pages/batches/batch-detail/all-strains/batches")),
);
const WalletDetail = LazyLoader(
  lazy(() => import("../pages/batches/batch-detail/wallet-detail")),
);

const AddAnnouncement = LazyLoader(
  lazy(() => import("../pages/announcements/add-announcements")),
);

const AnnouncementDetail = LazyLoader(
  lazy(() => import("../pages/announcements/announcement-detail")),
);

// const AddReward = LazyLoader(
//   lazy(() => import("../pages/rewards-management/add-reward"))
// );

const RewardDetail = LazyLoader(
  lazy(() => import("../pages/rewards-management/reward-detail")),
);

const SerailNumber = LazyLoader(
  lazy(() => import("../pages/qr-code-purchasing/serial-number")),
);
const SerailNumberDetail = LazyLoader(
  lazy(() => import("../pages/qr-code-purchasing/serial-number-detail")),
);
const TransactionDetail = LazyLoader(
  lazy(() => import("../pages/qr-code-purchasing/transaction-detail")),
);
const PaymentSuccess = LazyLoader(
  lazy(() => import("../pages/qr-code-purchasing/payment-success")),
);

const AddStrain = LazyLoader(lazy(() => import("../pages/strains/add-strain")));
const UploadStrains = LazyLoader(
  lazy(() => import("../pages/strains/upload-strains")),
);
const StrainDetail = LazyLoader(
  lazy(() => import("../pages/strains/strain-detail")),
);

const Notification = LazyLoader(lazy(() => import("../pages/notification")));

const UserNotFound = LazyLoader(
  lazy(() => import("../components/userNotFound")),
);

const SubscriptionDetails = LazyLoader(
  lazy(() => import("../pages/subscription/subscription-details")),
);

const StrainBatchDetail = LazyLoader(
  lazy(() => import("../pages/strains/strain-batch-detail")),
);

const BatchStrainDetail = LazyLoader(
  lazy(() => import("../pages/batches/batch-strain-detail")),
);

const Cart = LazyLoader(lazy(() => import("../pages/cart")));

const ReviewDetails = LazyLoader(
  lazy(() => import("../pages/batches/review-details")),
);

const BlockchainDetails = LazyLoader(
  lazy(() => import("../pages/batches/batch-detail/blockchain-details")),
);

const ConsumersManagement = LazyLoader(
  lazy(() => import("../pages/consumers-management")),
);

export const privateRoutesList = [
  {
    moduleId: 1,
    path: Paths.ANALYTICS,
    component: <Analytics />,
    modulekey: "analytics",
    pathName: Paths.ANALYTICS,
  },
  {
    moduleId: 2,
    path: Paths.SUPPORT_PAGE,
    component: <MySupport />,
    modulekey: "support",
    pathName: Paths.SUPPORT_PAGE,
  },
  {
    moduleId: 3,
    path: Paths.MY_PROFILE,
    component: <MyProfile />,
    modulekey: "",
    pathName: Paths.MY_PROFILE,
  },
  {
    moduleId: 4,
    path: Paths.COMPANY_PROFILE,
    component: <CompanyProfile />,
    modulekey: "company_profile",
    pathName: Paths.COMPANY_PROFILE,
  },
  {
    moduleId: 5,
    path: Paths.REWARDS_MANAGEMENT,
    component: <RewardsManagement />,
    modulekey: "rewards_management",
    pathName: Paths.REWARDS_MANAGEMENT,
  },
  {
    moduleId: 6,
    path: Paths.API_CONNECTIONS,
    component: <ApiConnections />,
    modulekey: "api_connection",
    pathName: Paths.API_CONNECTIONS,
  },
  {
    moduleId: 7,
    path: Paths.BATCHES,
    component: <Batches />,
    modulekey: "batches",
    pathName: Paths.BATCHES,
  },
  {
    moduleId: 8,
    path: Paths.EMPLOYEEES_MANAGEMENT,
    component: <EmployeesManagement />,
    modulekey: "employees_management",
    pathName: Paths.EMPLOYEEES_MANAGEMENT,
  },
  {
    moduleId: 9,
    path: Paths.STRAINS,
    component: <Strains />,
    modulekey: "strains",
    pathName: Paths.STRAINS,
  },
  {
    moduleId: 10,
    path: Paths.ANNOUNCEMENTS,
    component: <Announcements />,
    modulekey: "announcements",
    pathName: Paths.ANNOUNCEMENTS,
  },
  {
    moduleId: 11,
    path: Paths.EDIT_MY_PROFILE,
    component: <EditMyProfile />,
    modulekey: "",
    pathName: Paths.EDIT_MY_PROFILE,
  },
  {
    moduleId: 12,
    path: Paths.EDIT_COMPANY_PROFILE,
    component: <EditCompanyProfile />,
    modulekey: "company_profile",
    pathName: Paths.EDIT_COMPANY_PROFILE,
  },
  {
    moduleId: 13,
    path: Paths.ADD_EMPLOYEES,
    component: <AddEmployee />,
    modulekey: "employees_management",
    pathName: Paths.ADD_EMPLOYEES,
  },
  {
    moduleId: 14,
    path: Paths.EDIT_EMPLOYEES,
    component: <AddEmployee />,
    modulekey: "employees_management",
    pathName: Paths.EDIT_EMPLOYEES,
  },
  {
    moduleId: 15,
    path: Paths.QR_CODE_PURCHASING,
    component: <QRCodePurchasing />,
    modulekey: "qr_code",
    pathName: Paths.QR_CODE_PURCHASING,
  },
  {
    moduleId: 16,
    path: Paths.ACCESS_DENIED,
    component: <AccessDenied />,
    modulekey: "",
    pathName: Paths.ACCESS_DENIED,
  },
  {
    moduleId: 17,
    path: `${Paths.EDIT_EMPLOYEES}/:id`,
    component: <EditEmployee />,
    modulekey: "employees_management",
    pathName: Paths.EDIT_EMPLOYEES,
  },
  {
    moduleId: 18,
    path: `${Paths.EMPLOYEE_DETAIL}/:id`,
    component: <EmployeeDetail />,
    modulekey: "employees_management",
    pathName: Paths.EMPLOYEE_DETAIL,
  },
  {
    moduleId: 19,
    path: `${Paths.BATCH_DETAIL}/:id`,
    component: <BatcheDetail />,
    modulekey: "batches",
    pathName: Paths.BATCH_DETAIL,
  },
  {
    moduleId: 20,
    path: `${Paths.COA_TOKENIZE}/:id`,
    component: <COATokenize />,
    modulekey: "batches",
    pathName: Paths.COA_TOKENIZE,
  },
  {
    moduleId: 21,
    path: `${Paths.PRODUCT_TOKENIZE}/:id`,
    component: <ProductTokenize />,
    modulekey: "batches",
    pathName: Paths.PRODUCT_TOKENIZE,
  },
  // {
  //   moduleId: 22,
  //   path: `${Paths.UPLOAD_BATCHES}`,
  //   component: <UploadBatches />,
  //   modulekey: "batches",
  //   pathName: Paths.UPLOAD_BATCHES,
  // },

  {
    moduleId: 23,
    path: Paths.ADD_ANNOUNCEMENT,
    component: <AddAnnouncement />,
    modulekey: "announcements",
    pathName: Paths.ADD_ANNOUNCEMENT,
  },

  {
    moduleId: 25,
    path: `${Paths.ANNOUNCEMENT_DETAIL}/:id`,
    component: <AnnouncementDetail />,
    modulekey: "announcements",
    pathName: Paths.ANNOUNCEMENT_DETAIL,
  },
  {
    moduleId: 26,
    path: `${Paths.BATCH_CONSUMERS_DETAIL}/:consumerId`,
    component: <WalletDetail />,
    modulekey: "batches",
    pathName: Paths.BATCH_CONSUMERS_DETAIL,
  },
  {
    moduleId: 27,
    path: `${Paths.BATCH_DETAIL}/:id${Paths.ALL_BATCHES}/:id`,
    component: <AllBatches />,
    modulekey: "batches",
    pathName: `${Paths.BATCH_DETAIL}/:id/${Paths.ALL_BATCHES}/:id`,
  },
  {
    moduleId: 28,
    path: `${Paths.BATCH_DETAIL}/:id${Paths.ALL_STRAINS}/:id`,
    component: <AllStrains />,
    modulekey: "batches",
    pathName: `${Paths.BATCH_DETAIL}/:id/${Paths.ALL_STRAINS}/:id`,
  },
  // {
  //   moduleId: 29,
  //   path: `${Paths.ADD_REWARD}`,
  //   component: <AddReward />,
  //   modulekey: "rewards_management",
  //   pathName: Paths.ADD_REWARD,
  // },
  {
    moduleId: 30,
    path: `${Paths.REWARD_DETAIL}/:id`,
    component: <RewardDetail />,
    modulekey: "rewards_management",
    pathName: `${Paths.REWARD_DETAIL}/:id`,
  },
  {
    moduleId: 31,
    path: `${Paths.BATCH_DETAIL}/:id${Paths.ALL_STRAINS}/:id${Paths.BATCH}/:id`,
    component: <AllStrainsBatchDetail />,
    modulekey: "batches",
    pathName: `${Paths.BATCH_DETAIL}/:id/${Paths.ALL_STRAINS}/:id/${Paths.BATCH}/:id`,
  },
  {
    moduleId: 32,
    path: `${Paths.SERIAL_NUMBER}`,
    component: <SerailNumber />,
    modulekey: "qr_code",
    pathName: Paths.SERIAL_NUMBER,
  },
  {
    moduleId: 33,
    path: `${Paths.SERIAL_NUMBER_DETAIL}/:orderId`,
    component: <SerailNumberDetail />,
    modulekey: "qr_code",
    pathName: Paths.SERIAL_NUMBER_DETAIL,
  },
  {
    moduleId: 34,
    path: `${Paths.TRANSACTION_DETAIL}/:transactionId`,
    component: <TransactionDetail />,
    modulekey: "qr_code",
    pathName: `${Paths.TRANSACTION_DETAIL}`,
  },
  {
    moduleId: 35,
    path: `${Paths.PAYMENT_SUCESS}`,
    component: <PaymentSuccess />,
    modulekey: "qr_code",
    pathName: Paths.PAYMENT_SUCESS,
  },
  {
    moduleId: 36,
    path: `${Paths.ADD_STRAIN}`,
    component: <AddStrain />,
    modulekey: "strains",
    pathName: Paths.ADD_STRAIN,
  },
  {
    moduleId: 37,
    path: `${Paths.UPLOAD_STRAINS}`,
    component: <UploadStrains />,
    modulekey: "strains",
    pathName: Paths.UPLOAD_STRAINS,
  },
  {
    moduleId: 38,
    path: `${Paths.STRAIN_DETAIL}/:id`,
    component: <StrainDetail />,
    modulekey: "strains",
    pathName: Paths.STRAIN_DETAIL,
  },
  {
    moduleId: 39,
    path: `${Paths.Notification}`,
    component: <Notification />,
    modulekey: "strains",
    pathName: Paths.STRAIN_DETAIL,
  },
  {
    moduleId: 40,
    path: `${Paths.DETAIL_NOT_FOUND}`,
    component: <UserNotFound />,
    moduleKey: "userNotFound",
  },
  {
    moduleId: 42,
    path: `${Paths.EDIT_STRAIN}/:id`,
    component: <AddStrain />,
    modulekey: "strains",
    pathName: Paths.EDIT_STRAIN,
  },
  {
    moduleId: 43,
    path: `${Paths.ADD_INTEGRATION}`,
    component: <AddIntegration />,
    modulekey: "api_connection",
    pathName: Paths.ADD_INTEGRATION,
  },
  {
    moduleId: 44,
    path: `${Paths.INTEGRATION_DETAILS}/:integrationId`,
    component: <IntegrationDetails />,
    modulekey: "api_connection",
    pathName: Paths.INTEGRATION_DETAILS,
  },
  {
    moduleId: 45,
    path: `${Paths.EDIT_INTEGRATION}/:integrationId`,
    component: <EditIntegration />,
    modulekey: "api_connection",
    pathName: Paths.ADD_INTEGRATION,
  },

  {
    moduleId: 46,
    path: Paths.MY_SUBSCRIPTION,
    component: <SubscriptionDetails />,
    modulekey: "subscription details",
    pathName: Paths.MY_SUBSCRIPTION,
  },
  {
    moduleId: 47,
    path: Paths.ACCOUNT_LIST,
    component: <AccountListing />,
    modulekey: "account",
    pathName: Paths.ACCOUNT_LIST,
  },
  {
    moduleId: 48,
    path: `${Paths.ACCOUNT_DETAILS}/:sourceId`,
    component: <AccountDetails />,
    modulekey: "account",
    pathName: `${Paths.ACCOUNT_DETAILS}`,
  },
  {
    moduleId: 49,
    path: Paths.ADD_ACCOUNT,
    component: <AddAccount />,
    modulekey: "account",
    pathName: Paths.ADD_ACCOUNT,
  },
  {
    moduleId: 51,
    path: `${Paths.STRAIN_BATCH_DETAIL}/:id`,
    component: <StrainBatchDetail />,
    modulekey: "strains",
    pathName: Paths.STRAIN_BATCH_DETAIL,
  },
  {
    moduleId: 52,
    path: `${Paths.BATCH_STRAIN_DETAIL}/:id`,
    component: <BatchStrainDetail />,
    modulekey: "batches",
    pathName: Paths.BATCH_STRAIN_DETAIL,
  },

  {
    moduleId: 53,
    path: Paths.CART,
    component: <Cart />,
    modulekey: "qr_code",
    pathName: Paths.CART,
  },

  {
    moduleId: 54,
    path: `${Paths.REVIEW_DETAILS}/:id`,
    component: <ReviewDetails />,
    modulekey: "batches",
    pathName: Paths.REVIEW_DETAILS,
  },

  {
    moduleId: 55,
    path: `${Paths.BATCH_BLOCKCHAIN_VIEW}/:id`,
    component: <BlockchainDetails />,
    modulekey: "batches",
    pathName: Paths.BATCH_BLOCKCHAIN_VIEW,
  },
  {
    moduleId: 56,
    path: Paths.CONSUMERS_MANAGEMENT,
    component: <ConsumersManagement />,
    modulekey: "consumers",
    pathName: Paths.CONSUMERS_MANAGEMENT,
  },
  {
    moduleId: 57,
    path: `${Paths.CONSUMERS_MANAGEMENT_DETAIL}/:consumerId`,
    component: <WalletDetail />,
    modulekey: "consumers",
    pathName: Paths.CONSUMERS_MANAGEMENT_DETAIL,
  },
];
